import { render } from "./SubscriptionLink.vue?vue&type=template&id=5fa65f94&ts=true"
import script from "./SubscriptionLink.vue?vue&type=script&lang=ts"
export * from "./SubscriptionLink.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/diego/Projects/SL360/spylive360/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__